import React from 'react';
import { Outlet } from 'react-router-dom';
import Topbar from './Topbar';

/** App chrome for authenticated pages: the design's `.app` container + topbar. */
export default function Layout() {
  return (
    <div className="app">
      <Topbar />
      <Outlet />
    </div>
  );
}
